<template>
  <div id="iContent">
    <div>
      <div>
        <div>
          <img style="width: 100%;height: 100%;" :src="tableData.images" />
        </div>
        <div style="font-size: 18px;line-height: 2.5rem;" v-html="tableData.contents"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        tableData: [],
        loading: false
      }
    },
    mounted() {
      this.handleSearch()
    },
    methods: {
      handleSearch() {
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/introduce/introduceOne/2';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.tableData = cData.data;
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #iContent {
    width: 100%;
  }

  #iContent>div:nth-child(1) {
    width: 94%;
    margin: 10px 3%;
  }

  #iContent>div:nth-child(1)>div {
    width: 100%;
  }

  #iContent>div:nth-child(1)>div>div:nth-child(1) {
    height: 600px;
  }
  #iContent>div:nth-child(1)>div>div:nth-child(2) {
    padding-top: 1.875rem;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about/introduction.vue